import type { TFunction } from 'i18next';

const errorKeyMap: Record<string, string> = {
    'Invalid credentials': 'login.invalidCredentials',
    'Your account is pending approval': 'login.pendingApproval',
    'Passwords do not match.': 'register.passwordMismatch',
    'Constancia document is required for job seekers.': 'register.constanciaRequired',
    'CUIT/CUIL document is required for job posters.': 'register.cuitCuilRequired',
    'CUIT/CUIL number is required for job posters.': 'register.cuitCuilNumberRequired',
    'CUIT/CUIL number must be 11 digits.': 'register.cuitCuilNumberInvalid',
    'email: This field is required.': 'register.emailRequired',
    'email: This field may not be blank.': 'register.emailRequired',
    'email: Enter a valid email address.': 'register.emailInvalid',
    'The fields email, user_type must make a unique set.': 'register.emailAlreadyRegistered',
    'Admin or moderator accounts cannot be created via registration.': 'register.adminNotAllowed',
    'Phone number is required.': 'register.phoneRequired',
    'Phone number format is invalid.': 'register.phoneInvalid',
    'Phone number must be a mobile number.': 'register.phoneInvalid',
    'Phone number must be at least 10 digits.': 'register.phoneInvalid',
    'DNI is required for job seekers.': 'register.dniRequired',
    'DNI must be 6 to 8 digits.': 'register.dniInvalid',
    'Terms must be accepted.': 'register.termsRequired',
    'Privacy policy must be accepted.': 'register.termsRequired',
    'Your account is pending approval.': 'register.pendingApproval',
    'Constancia document debe ser PDF, JPG, PNG, DOC o DOCX.': 'register.constanciaInvalidType',
    'Constancia document must be PDF, JPG, PNG, DOC or DOCX.': 'register.constanciaInvalidType',
    'Constancia document debe pesar 10MB o menos.': 'register.constanciaMaxSize',
    'Constancia document must be 10MB or less.': 'register.constanciaMaxSize',
};

const passwordErrorParts = [
    'Password must contain at least one uppercase letter.',
    'Password must contain at least one number.',
    'Password must contain at least one symbol.',
];

export const mapApiError = (
    error: unknown,
    t: TFunction,
    fallbackKey: string
): string => {
    if (error instanceof Error) {
        const normalizedMessage = error.message.replace(/^non_field_errors:\s*/i, '');
        if (
            normalizedMessage.startsWith('Constancia document debe pesar') ||
            /Constancia document must be\s+\d+\s*MB\s+or less\.?/i.test(normalizedMessage)
        ) {
            return t('register.constanciaMaxSize');
        }
        if (
            normalizedMessage.startsWith('Constancia document debe ser') ||
            normalizedMessage === 'Constancia document must be PDF, JPG, PNG, DOC or DOCX.'
        ) {
            return t('register.constanciaInvalidType');
        }
        if (normalizedMessage.startsWith('password:')) {
            const hasAllParts = passwordErrorParts.every((part) => normalizedMessage.includes(part));
            if (hasAllParts) {
                return t('register.passwordComplexity');
            }
            return t('register.passwordComplexity');
        }
        const mappedKey = errorKeyMap[normalizedMessage] || errorKeyMap[error.message];
        if (mappedKey) {
            return t(mappedKey);
        }
        return error.message || t(fallbackKey);
    }

    return t(fallbackKey);
};
